/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Amorim API v1
 * Amorim API v1 — Public-facing endpoints (CMS, authentication, authenticated user resources, reservations).
 *
 * **Authentication**
 *
 * - All requests require an `Api-Key` header.
 * - Endpoints that operate on the authenticated user additionally require `Authorization: Bearer <jwt>`.
 * OpenAPI spec version: v1
 */
import type {
  AddressBookDto,
  SaveAddressRequest,
  SetPreferredAddressRequest
} from '../model';

import { customFetch } from '../../../custom-fetch.ts';

export type getMeAddressesV1Response200 = {
  data: AddressBookDto[]
  status: 200
}

export type getMeAddressesV1Response401 = {
  data: void
  status: 401
}

export type getMeAddressesV1ResponseSuccess = (getMeAddressesV1Response200) & {
  headers: Headers;
};
export type getMeAddressesV1ResponseError = (getMeAddressesV1Response401) & {
  headers: Headers;
};

export type getMeAddressesV1Response = (getMeAddressesV1ResponseSuccess | getMeAddressesV1ResponseError)

export const getGetMeAddressesV1Url = () => {




  return `/api/v1/me/addresses`
}

/**
 * Returns all active addresses for the authenticated user. Preferred addresses appear first.
 * @summary List address book entries
 */
export const getMeAddressesV1 = async ( options?: Parameters<typeof customFetch>[1]): Promise<getMeAddressesV1Response> => {

  return customFetch<getMeAddressesV1Response>(getGetMeAddressesV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}


export type createMeAddressV1Response201 = {
  data: AddressBookDto
  status: 201
}

export type createMeAddressV1Response400 = {
  data: void
  status: 400
}

export type createMeAddressV1Response401 = {
  data: void
  status: 401
}

export type createMeAddressV1ResponseSuccess = (createMeAddressV1Response201) & {
  headers: Headers;
};
export type createMeAddressV1ResponseError = (createMeAddressV1Response400 | createMeAddressV1Response401) & {
  headers: Headers;
};

export type createMeAddressV1Response = (createMeAddressV1ResponseSuccess | createMeAddressV1ResponseError)

export const getCreateMeAddressV1Url = () => {




  return `/api/v1/me/addresses`
}

/**
 * Creates a new address book entry. If IsPreferredDelivery or IsPreferredBilling is true, the flag is cleared from any existing address and the new address is synced to MuleSoft.
 * @summary Add a new address
 */
export const createMeAddressV1 = async (saveAddressRequest: SaveAddressRequest, options?: Parameters<typeof customFetch>[1]): Promise<createMeAddressV1Response> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<createMeAddressV1Response>(getCreateMeAddressV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(saveAddressRequest)
  }
);}


export type updateMeAddressV1Response200 = {
  data: AddressBookDto
  status: 200
}

export type updateMeAddressV1Response400 = {
  data: void
  status: 400
}

export type updateMeAddressV1Response401 = {
  data: void
  status: 401
}

export type updateMeAddressV1Response404 = {
  data: void
  status: 404
}

export type updateMeAddressV1ResponseSuccess = (updateMeAddressV1Response200) & {
  headers: Headers;
};
export type updateMeAddressV1ResponseError = (updateMeAddressV1Response400 | updateMeAddressV1Response401 | updateMeAddressV1Response404) & {
  headers: Headers;
};

export type updateMeAddressV1Response = (updateMeAddressV1ResponseSuccess | updateMeAddressV1ResponseError)

export const getUpdateMeAddressV1Url = (id: string,) => {




  return `/api/v1/me/addresses/${id}`
}

/**
 * Updates an existing address book entry. Preferred flags and MuleSoft sync follow the same rules as create.
 * @summary Update an address
 */
export const updateMeAddressV1 = async (id: string,
    saveAddressRequest: SaveAddressRequest, options?: Parameters<typeof customFetch>[1]): Promise<updateMeAddressV1Response> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<updateMeAddressV1Response>(getUpdateMeAddressV1Url(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(saveAddressRequest)
  }
);}


export type deleteMeAddressV1Response204 = {
  data: void
  status: 204
}

export type deleteMeAddressV1Response401 = {
  data: void
  status: 401
}

export type deleteMeAddressV1Response404 = {
  data: void
  status: 404
}

export type deleteMeAddressV1ResponseSuccess = (deleteMeAddressV1Response204) & {
  headers: Headers;
};
export type deleteMeAddressV1ResponseError = (deleteMeAddressV1Response401 | deleteMeAddressV1Response404) & {
  headers: Headers;
};

export type deleteMeAddressV1Response = (deleteMeAddressV1ResponseSuccess | deleteMeAddressV1ResponseError)

export const getDeleteMeAddressV1Url = (id: string,) => {




  return `/api/v1/me/addresses/${id}`
}

/**
 * Soft-deletes the address. Preferred flags are cleared but no MuleSoft sync is triggered.
 * @summary Delete an address
 */
export const deleteMeAddressV1 = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<deleteMeAddressV1Response> => {

  return customFetch<deleteMeAddressV1Response>(getDeleteMeAddressV1Url(id),
  {
    ...options,
    method: 'DELETE'


  }
);}


export type setMeAddressPreferredV1Response200 = {
  data: AddressBookDto
  status: 200
}

export type setMeAddressPreferredV1Response400 = {
  data: void
  status: 400
}

export type setMeAddressPreferredV1Response401 = {
  data: void
  status: 401
}

export type setMeAddressPreferredV1Response404 = {
  data: void
  status: 404
}

export type setMeAddressPreferredV1ResponseSuccess = (setMeAddressPreferredV1Response200) & {
  headers: Headers;
};
export type setMeAddressPreferredV1ResponseError = (setMeAddressPreferredV1Response400 | setMeAddressPreferredV1Response401 | setMeAddressPreferredV1Response404) & {
  headers: Headers;
};

export type setMeAddressPreferredV1Response = (setMeAddressPreferredV1ResponseSuccess | setMeAddressPreferredV1ResponseError)

export const getSetMeAddressPreferredV1Url = (id: string,) => {




  return `/api/v1/me/addresses/${id}/preferred`
}

/**
 * Marks the address as preferred delivery and/or billing. Clears the flag from any other address. Syncs the relevant address block(s) to MuleSoft (shippingAddress / billingAddress). At least one of Delivery or Billing must be true.
 * @summary Set address as preferred
 */
export const setMeAddressPreferredV1 = async (id: string,
    setPreferredAddressRequest: SetPreferredAddressRequest, options?: Parameters<typeof customFetch>[1]): Promise<setMeAddressPreferredV1Response> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<setMeAddressPreferredV1Response>(getSetMeAddressPreferredV1Url(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setPreferredAddressRequest)
  }
);}


